const TEMP_ATTACHMENT_ID_PREFIX = "temp-"

export function tempAttachmentId(name: string) {
  return `${TEMP_ATTACHMENT_ID_PREFIX}${name}-${Date.now()}-${Math.random()}`
}

export function isTempAttachmentId(id: string) {
  return Boolean(id && id.startsWith(TEMP_ATTACHMENT_ID_PREFIX))
}
